import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { markAsCanceledAPIAction } from '../../../api/markAsCanceledAPIAction';
import { useStore } from '../../../../../../store';
import { INVOICE_STATUSES } from '../../../consts/consts';
import { InvoiceCancelSuccess } from '../../Toasts/InvoiceCancelSuccess';
import { HUB_MODALS } from '../../InvoiceHubModals';

interface IProps {
  externalId: string;
  invoiceNumber: string;
  invoiceStatus: string;
  onClose: () => void;
}

export const CancelInvoice = ({ externalId, invoiceNumber, invoiceStatus, onClose }: IProps) => {
  const { currUser } = useStore.getState();
  const setActiveModal = useStore((state) => state.setActiveModal);
  const setError = useStore((state) => state.setError);
  const removeInvoiceFromList = useStore((state) => state.removeInvoiceFromList);
  const { t } = useTranslation();
  const handleCancelInvoice = async () => {
    try {
      setActiveModal(HUB_MODALS.SPINNER);
      const response = await markAsCanceledAPIAction(currUser()?.customerId, externalId);
      setActiveModal(HUB_MODALS.NONE);
      if (response?.invoiceStatus === INVOICE_STATUSES.CANCEL) {
        toast(<InvoiceCancelSuccess invoiceNumber={invoiceNumber} />, {
          position: toast.POSITION.TOP_CENTER,
          className: 'w-[343px] h-[44px] bg-bw08 p-0',
        });
        removeInvoiceFromList(invoiceStatus, externalId);
      }
    } catch (error: any) {
      setError(error);
      setActiveModal(HUB_MODALS.ERROR);
    }
  };
  return (
    <div className='cursor-default flex flex-nowrap flex-col h-[220px] w-[498px] bg-bw00 rounded-lg border-[1px] border-bw03 p-[24px] box-border'>
      <div className='text-bw08 font-metricRMedium leading-8 text-24'>
        {t('INVOICE_HUB_MODALS.CANCEL_INVOICE.TITLE')}
        <span data-testid='invoiceNumberInCancelPopup'>{` #${invoiceNumber}?`}</span>
      </div>
      <div className='text-bw07 font-metricR leading-6 text-lg'>{t('INVOICE_HUB_MODALS.CANCEL_INVOICE.SUBTITLE')}</div>
      <div className='text-bw07 font-metricR leading-6 text-lg mt-[8px]'>
        {t('INVOICE_HUB_MODALS.CANCEL_INVOICE.LIST_TITLE')}
      </div>
      <div className='mt-[20px] flex justify-end gap-2.5'>
        <LiliButton
          id='doNotCancel'
          testId='doNotCancel'
          type={LiliButtonType.TERTIARY}
          title={t('INVOICE_HUB_MODALS.CANCEL_INVOICE.DONT_CANCEL')}
          className='w-[140px] h-[40px]'
          onClick={onClose}
        />
        <LiliButton
          id='yesCancelIt'
          testId='yesCancelIt'
          type={LiliButtonType.DESTRUCTIVE}
          title={t('INVOICE_HUB_MODALS.CANCEL_INVOICE.CANCEL')}
          className='w-[140px] h-[40px]'
          onClick={handleCancelInvoice}
        />
      </div>
    </div>
  );
};
